import { render, staticRenderFns } from "./JKYT.vue?vue&type=template&id=4f356668&scoped=true&"
import script from "./JKYT.vue?vue&type=script&lang=js&"
export * from "./JKYT.vue?vue&type=script&lang=js&"
import style0 from "./JKYT.vue?vue&type=style&index=0&id=4f356668&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f356668",
  null
  
)

export default component.exports